export default function(timeOut = 2000) {
    const linkCopied = ref(false);

    const copyToClipboard = async(text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            linkCopied.value = true;
            setTimeout(() => {
                linkCopied.value = false;
            }, timeOut);
            return true;
        } catch (error) {
            console.error('Failed to copy text to clipboard:', error);
            linkCopied.value = false;
            return false;
        }
    };

    return { copyToClipboard, linkCopied };
}
